import React from 'react'

import WidgetIcon from '../../../Atoms/WidgetIcon/WidgetIcon'
import { ReactComponent as RowChartWidgetIconSvg } from './RowChartWidget.Icon.Row.svg'
import { ReactComponent as BarChartWidgetIconSvg } from './RowChartWidget.Icon.Bar.svg'

export default (isRowChart: boolean) => () =>
    <WidgetIcon icon={isRowChart ? RowChartWidgetIconSvg : BarChartWidgetIconSvg} />
